module.exports = __webpack_public_path__ + "static/img/1.bb221a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/1.png
// module id = Lyzx
// module chunks = 0